import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const storeFinderConfirmationPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page("store-finder/confirmation"),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>("/page-data/store-finder/confirmation"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
